import { Icon20Cancel } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { type FC, type MouseEvent } from 'react';
import { MenuButton } from 'reactApp/ui/ReactViewer/ViewerMenu/MenuButton/MenuButton';

import styles from './CloseMenuButton.css';

interface Props {
    onClick?: (evt: MouseEvent) => void;
    withSeparator?: boolean;
}

export const CloseMenuButton: FC<Props> = (props) => {
    const { onClick, withSeparator = true } = props;

    return (
        <MenuButton
            className={classNames({ [styles.buttonWithSeparator]: withSeparator })}
            hint="Закрыть"
            icon={<Icon20Cancel />}
            onClick={onClick}
        />
    );
};
